class DillerConnectController extends AbstractIntegrationController
	@register()

	integrationId: 'diller'
